export default defineNuxtPlugin(() => {
    const desktopNavbar = document.getElementById('navbar');
    const mobileNavbar = document.getElementById('mobile-navbar');

    if (!import.meta.client) {
        return;
    }

    let currentScrollY = 0;
    let rendering = false;

    const container = document.getElementById('nav-stopper');
    const scrollHeaderBtn = document.getElementById('home-btn-scroll');
    const getStartedBtn = document.getElementById('get-started-btn');

    // Desktop navbar scroll behavior
    const render = () => {
        if (desktopNavbar && !desktopNavbar.classList.contains('nav-fixed')) {
            if (currentScrollY < (container?.offsetTop - desktopNavbar.offsetHeight)) {
                desktopNavbar?.classList?.remove('nav-fixed-light');
                document.querySelectorAll('.menu-text').forEach(el => {
                    el.classList.add('text-white');
                    el.classList.remove('text-green-light');
                });

                document.getElementById('header-logo-light')?.classList?.remove('d-none');
                document.getElementById('header-logo-dark')?.classList?.add('d-none');
            } else if (!desktopNavbar.classList.contains('nav-fixed-light')) {
                desktopNavbar?.classList?.add('nav-fixed-light');
                document.querySelectorAll('.menu-text').forEach(el => {
                    el.classList.remove('text-white');
                    el.classList.add('text-green-light');
                });

                document.getElementById('header-logo-light')?.classList?.add('d-none');
                document.getElementById('header-logo-dark')?.classList?.remove('d-none');
            }
        }
        rendering = false;
    }

    const onScroll = () => {
        currentScrollY = window.scrollY;
        if (rendering) {
            return;
        }
        requestAnimationFrame(render);
    };

    const doScroll = (event) => {
        var currentBtn = event.currentTarget;
        const nextContainer = document.getElementById(currentBtn?.dataset?.nextId);

        if (nextContainer) {
            let offsetHeight = 250;

            const isMobile = window.innerWidth < 768;

            if (isMobile && mobileNavbar) {
                offsetHeight = mobileNavbar.offsetHeight - 30;
            } else if (desktopNavbar) {
                offsetHeight = desktopNavbar.offsetHeight - 60;
            }

            window.scrollTo({
                top: (nextContainer.offsetTop - offsetHeight),
                behavior: 'smooth',
            });
        }
    }

    // Desktop navbar scroll behavior
    if (desktopNavbar) {
        window.addEventListener('scroll', onScroll);
        onScroll();
    }

    // Scroll button functionality
    if (scrollHeaderBtn) {
        scrollHeaderBtn.addEventListener('click', doScroll);
    }

    if (getStartedBtn) {
        getStartedBtn.addEventListener('click', doScroll);
    }

    const mobileNavArrows = document.querySelectorAll('.mobile-nav-arrow');

    mobileNavArrows.forEach(arrow => {
        arrow.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const navItem = this.closest('.navbar-dropdown');
            const dropdownMenu = navItem?.querySelector('.dropdown-menu');

            if (dropdownMenu) {
                dropdownMenu.classList.toggle('show');

                const allDropdowns = document.querySelectorAll('.dropdown-menu');
                allDropdowns.forEach(dropdown => {
                    if (dropdown !== dropdownMenu) {
                        dropdown.classList.remove('show');
                    }
                });
            }
        });
    });

    const setupHamburgerTransition = () => {
        const mobileSidebar = document.getElementById('mobile-sidebar');
        const toggleBtn = document.querySelector('.mobile-toggle-btn');

        if (mobileSidebar && toggleBtn) {
            mobileSidebar.removeEventListener('show.bs.offcanvas', handleShow);
            mobileSidebar.removeEventListener('hide.bs.offcanvas', handleHide);

            function handleShow() {
                toggleBtn.classList.add('is-active');
            }

            function handleHide() {
                toggleBtn.classList.remove('is-active');
            }

            mobileSidebar.addEventListener('show.bs.offcanvas', handleShow);

            mobileSidebar.addEventListener('hide.bs.offcanvas', handleHide);
        }
    };

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
                setupHamburgerTransition();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    setupHamburgerTransition();

});
